import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _34a7e22a = () => interopDefault(import('../../../pages/categories/business.vue' /* webpackChunkName: "pages/categories/business" */))
const _21fbd28c = () => interopDefault(import('../../../pages/categories/get-inspired.vue' /* webpackChunkName: "pages/categories/get-inspired" */))
const _0b14a901 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _7eec59fe = () => interopDefault(import('../../../pages/categories/news.vue' /* webpackChunkName: "pages/categories/news" */))
const _3c2d75e0 = () => interopDefault(import('../../../pages/preview.vue' /* webpackChunkName: "pages/preview" */))
const _387b089e = () => interopDefault(import('../../../pages/categories/printstories.vue' /* webpackChunkName: "pages/categories/printstories" */))
const _f2792d16 = () => interopDefault(import('../../../pages/editorial-staff/index.vue' /* webpackChunkName: "pages/editorial-staff/index" */))
const _f3a425fa = () => interopDefault(import('../../../pages/categories/how-to.vue' /* webpackChunkName: "pages/categories/how-to" */))
const _416d05ea = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _8c5dc6e6 = () => interopDefault(import('../../../pages/editorial-staff/_author.vue' /* webpackChunkName: "pages/editorial-staff/_author" */))
const _b7d9dfd2 = () => interopDefault(import('../../../pages/_post.vue' /* webpackChunkName: "pages/_post" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/blog/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/business/",
    component: _34a7e22a,
    pathToRegexpOptions: {"strict":true},
    name: "categories-business___de"
  }, {
    path: "/inspiration/",
    component: _21fbd28c,
    pathToRegexpOptions: {"strict":true},
    name: "categories-get-inspired___de"
  }, {
    path: "/login/",
    component: _0b14a901,
    pathToRegexpOptions: {"strict":true},
    name: "login___de"
  }, {
    path: "/news/",
    component: _7eec59fe,
    pathToRegexpOptions: {"strict":true},
    name: "categories-news___de"
  }, {
    path: "/preview/",
    component: _3c2d75e0,
    pathToRegexpOptions: {"strict":true},
    name: "preview___de"
  }, {
    path: "/printstories/",
    component: _387b089e,
    pathToRegexpOptions: {"strict":true},
    name: "categories-printstories___de"
  }, {
    path: "/redaktion/",
    component: _f2792d16,
    pathToRegexpOptions: {"strict":true},
    name: "editorial-staff___de"
  }, {
    path: "/so-wirds-gemacht/",
    component: _f3a425fa,
    pathToRegexpOptions: {"strict":true},
    name: "categories-how-to___de"
  }, {
    path: "/",
    component: _416d05ea,
    pathToRegexpOptions: {"strict":true},
    name: "index___de"
  }, {
    path: "/redaktion/:author?/",
    component: _8c5dc6e6,
    pathToRegexpOptions: {"strict":true},
    name: "editorial-staff-author___de"
  }, {
    path: "/:post/",
    component: _b7d9dfd2,
    pathToRegexpOptions: {"strict":true},
    name: "post___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
